import {
  type schemaType,
  type returnType,
} from '~~/shared/api/rurality/v3/regions/list/schema'
import {
  serverFetchWrapper,
  browserFetchWrapper,
} from '~~/server/utils/rurality/v3/endpointWrapper'

const endpoint = '/regions/list'

export const serverFetch = (): Promise<returnType> =>
  serverFetchWrapper<never, schemaType>(endpoint)

export const browserFetch = (): Promise<returnType> =>
  browserFetchWrapper<never, schemaType>(endpoint)
